
import React from 'react'

const APIUrl = `${window.location.origin}/api/v1/subscriptions/${window.location.href.split("unsubscribe/")[1]}`;
 
export default class Unsubscribe extends React.Component {
    constructor() {
        super();
        this.state = {
          loading: true,
          error: null,
          message: "",
        };
      }
  
    componentDidMount() {
        fetch(APIUrl,{
            method: "DELETE",
        })
            .then(response => {
                if (response.ok) {
                    this.setState({ message: "You have been unsubscribed.", loading: true });
                } else {
                    this.setState({ message: `${response.status} error occured`,error: 'error', loading: true });
                }
                return response.json();
            })
            .then(data =>{
                this.setState({ loading: false });
                this.setState({ message: data.message|| this.state.message });
            })
            .catch(error => {
                this.setState({ error: "error", loading: false });
                this.setState({ message: this.state.message || " Some error occured while unsubscribing."});
                throw error;
            }).finally(()=>{
                window.history.replaceState(null, '', window.location.origin);
            });
      }
 
    render() {
        const { message, loading, error } = this.state;
        if (error) {
            return (
                <div className="alert-center" style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '50vh'
                }}>
                <div className="alert alert-danger" role="alert" > <span><strong>Oh snap! </strong>{message}</span></div>
                </div>
                )
        }
 
        return (
            <div className="container bootstrap-scope main-body-adjustment">
                {loading ?<div className="info">
					<div className="loading-container">
						<div className="loading" />
					</div>
				</div>
                :
                <div className="alert-center" style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '50vh'
                }}>
                <div className="alert alert-success" role="alert" >{message}</div>
                 </div>
                }
            </div>
        )
    }
}
 